module.exports = "images/favicon-32x32.9a052e75708a594104add4ed5914fc58.png";